<input type="text" 
    class="form-control text-right"
    #input
    [class.ng-invalid]="ngControl.invalid"
    [ngStyle]="style"
    [name]="name"
    [id]="id"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    (focus)="onFocus($event)"
    (focusout)="onFocusout($event)"
    (keyup)="onKeyup($event)"
    (change)="onChange($event)"
    [placeholder]="placeholder"
    autocomplete="off">